import * as React from 'react';
import { Label } from './TaskFilters.styles';
import { ArrayParam, useQueryParams } from 'use-query-params';
import { debounce } from 'lodash';

export const BookkeepingIdsFilter = () => {
  const [query, setQuery] = useQueryParams({ bookkeeperIds: ArrayParam });
  const [bookkeeperIdsString, setBookkeeperIdsString] = React.useState<string>(
    query.bookkeeperIds?.filter(id => id !== null).join(',') || '',
  );

  const handleInputChangeEvent = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    const cleanValue = value.replace(/\s/g, '');
    setBookkeeperIdsString(cleanValue);
    handleInputChangeEventDebounced(cleanValue);
  };

  const handleInputChangeEventDebounced = debounce((value: string) => {
    const idsArray = value ? value.split(',') : [];
    setQuery({ bookkeeperIds: idsArray }, 'pushIn');
  }, 1000);

  return (
    <span>
      <Label>Bookkeeper Ids</Label>
      <input
        aria-label="bookkeeper id input"
        name="bookkeeperIds"
        placeholder="eg: 67284, 1827365..."
        value={bookkeeperIdsString}
        onChange={handleInputChangeEvent}
      />
    </span>
  );
};
